import { Routes } from '@angular/router';
import { OrganisationInvitationValidationComponent } from '@suvo/frontend-framework/SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/invitations/organisations/components/organisation-invitation-validation/organisation-invitation-validation.component';
import { createDynamicRouteResolver } from '../../dynamic-routes';
import { PublicDashboardScreenComponent } from '../private/dashboards/screens/public-dashboard-screen/public-dashboard-screen.component';
import { EmailVerificationMessageComponent } from './components/email-verification-message/email-verification-message.component';
import { LoginComponent } from './components/login/login.component';
import { publicLanguageGuard } from './guards/public-language.guard';
import { PublicComponent } from './public.component';
import { FaqsScreenComponent } from './screens/faqs-screen/faqs-screen.component';
import { IdentityComponent } from './screens/identity/identity.component';
import { PricingComponent } from './screens/pricing/pricing.component';
import { PrivacyPolicyComponent } from './screens/privacy-policy/privacy-policy.component';
import { RegisterComponent } from './screens/register/register.component';
import { ResetPasswordConfirmationScreenComponent } from './screens/reset-password-confirmation-screen/reset-password-confirmation-screen.component';
import { TermsAndConditionsComponent } from './screens/terms/terms-and-conditions.component';
import { VerifyComponent } from './screens/verify/verify.component';
import { VerifyEmailConfirmationScreenComponent } from './screens/verify-email/verify-email-confirmation-screen.component';

export default [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'en',
  },
  {
    path: 'login',
    pathMatch: 'full',
    redirectTo: 'en/identity',
  },
  {
    path: 'register',
    pathMatch: 'full',
    redirectTo: 'en/register',
  },
  {
    path: 'verify',
    pathMatch: 'full',
    redirectTo: 'en/identity/verify',
  },
  {
    path: 'invites',
    pathMatch: 'full',
    component: OrganisationInvitationValidationComponent,
  },
  {
    path: 'login/:token/:email',
    pathMatch: 'full',
    redirectTo: 'en/identity/:token/:email',
  },
  {
    path: 'email-verification-message/:email',
    pathMatch: 'full',
    redirectTo: 'en/identity/email-verify/:email',
  },
  {
    path: 'register/:token/:email',
    pathMatch: 'full',
    redirectTo: 'en/register/:token/:email',
  },
  {
    path: 'privacy-policy',
    pathMatch: 'full',
    redirectTo: 'en/privacy-policy',
  },
  {
    path: 'faqs',
    pathMatch: 'full',
    redirectTo: 'en/faqs',
  },
  {
    path: 'terms-and-conditions',
    pathMatch: 'full',
    redirectTo: 'en/terms-and-conditions',
  },
  {
    path: 'verify-email/confirmation',
    pathMatch: 'full',
    redirectTo: 'en/verify-email/confirmation',
  },
  {
    path: 'reset-password/confirmation',
    pathMatch: 'full',
    redirectTo: 'en/reset-password/confirmation',
  },
  {
    path: 'identity',
    pathMatch: 'full',
    redirectTo: 'en/identity',
  },
  {
    path: 'identity/verify-email',
    pathMatch: 'full',
    redirectTo: 'en/identity/verify',
  },
  {
    path: 'identity/login',
    pathMatch: 'full',
    redirectTo: 'en/identity',
  },
  {
    path: 'home',
    pathMatch: 'full',
    redirectTo: 'en/home',
  },
  {
    path: ':language',
    component: PublicComponent,
    canActivate: [publicLanguageGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
      },
      {
        path: 'pricing',
        pathMatch: 'full',
        component: PricingComponent,
        data: {
          seo: {
            title: 'Pricing',
            description: 'Compare pricing of the range of subscriptions.',
          },
        },
      },
      {
        path: 'register',
        pathMatch: 'full',
        component: RegisterComponent,
        data: {
          seo: {
            title: 'Register',
            description: 'Register for a free tiral of the IRJ Pro platform today.',
          },
        },
      },
      { path: 'register/:token/:email', pathMatch: 'full', component: RegisterComponent },
      { path: 'privacy-policy', pathMatch: 'full', component: PrivacyPolicyComponent },
      {
        path: 'faqs',
        pathMatch: 'full',
        component: FaqsScreenComponent,
        data: {
          seo: {
            title: 'FAQs',
            description:
              'Answers to the most frequently asked questions about the IRJ Pro platform.',
          },
        },
      },
      { path: 'terms-and-conditions', pathMatch: 'full', component: TermsAndConditionsComponent },
      {
        path: 'verify-email/confirmation',
        pathMatch: 'full',
        component: VerifyEmailConfirmationScreenComponent,
      },
      {
        path: 'reset-password/confirmation',
        pathMatch: 'full',
        component: ResetPasswordConfirmationScreenComponent,
      },
      {
        path: 'identity',
        component: IdentityComponent,
        children: [
          { path: '', pathMatch: 'full', component: LoginComponent },
          { path: 'verify-email', pathMatch: 'full', redirectTo: 'verify' },
          {
            path: 'email-verify/:email',
            pathMatch: 'full',
            component: EmailVerificationMessageComponent,
          },
          { path: ':token/:email', pathMatch: 'full', component: LoginComponent },
          {
            path: 'login',
            pathMatch: 'full',
            redirectTo: '',
            data: {
              seo: {
                title: 'Log in',
                description: 'Log in to your IRJ Pro account.',
              },
            },
          },
          { path: 'verify', pathMatch: 'full', component: VerifyComponent },
        ],
      },
      {
        path: '**',
        component: PublicDashboardScreenComponent,
        resolve: { dynamicRoute: createDynamicRouteResolver('public') },
        data: { breadcrumbDynamic: 'dashboard' },
      },
    ],
  },
] satisfies Routes;
